'use strict';

module.exports = {
    eventCategories: require('./eventCategories'),
    eventResults: require('./eventResults'),
    eventTypesByCategory: require('./eventTypesByCategory'),
    principalTypes: require('./principalTypes'),
    data: require('./data')
};